// src/components/Footer.js

function Footer() {
  return (
    
    // py-8 (üst-alt boşluk) değeri py-6 olarak düşürüldü
    <footer className="bg-gray-800 text-white py-1 mt-16">
      <div className="container mx-auto text-center">
        <p>© 2025 StandPro. Tüm hakları saklıdır.</p>
        <p className="text-sm text-gray-400 mt-2">Antalya, Türkiye</p>
      </div>
    </footer>
  );
}

export default Footer;